import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = `${apiMainUrl}sap-company-configs`;

/*───────────────────────────────────────────────────────────────────────────
  Company-configuration CRUD helpers
  - createCompanyConfig
  - getAllCompanyConfigs
  - getCompanyConfigById
  - updateCompanyConfig
  - deleteCompanyConfig
───────────────────────────────────────────────────────────────────────────*/

/* Create (POST) */
const createCompanyConfig = async (dto, token) => {
  try {
    const { data } = await axios.post(API_BASE_URL, dto, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return data;                        // returns the created object
  } catch (err) {
    console.error('Failed to create company-config:', err);
    throw err;
  }
};

/* Read-all (GET) */
const getAllCompanyConfigs = async (token) => {
  try {
    const { data } = await axios.get(API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return data;
  } catch (err) {
    console.error('Failed to fetch company configs:', err);
    throw err;
  }
};

/* Read-one (GET /{id}) */
const getCompanyConfigById = async (id, token) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return data;
  } catch (err) {
    console.error(`Failed to fetch company-config ${id}:`, err);
    throw err;
  }
};

/* Update (PUT /{id}) */
const updateCompanyConfig = async (id, dto, token) => {
  try {
    const { data } = await axios.put(`${API_BASE_URL}/${id}`, dto, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return data;                        // normally empty (204) but returned for symmetry
  } catch (err) {
    console.error(`Failed to update company-config ${id}:`, err);
    throw err;
  }
};

/* Delete (DELETE /{id}) */
const deleteCompanyConfig = async (id, token) => {
  try {
    return await axios.delete(`${API_BASE_URL}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  } catch (err) {
    console.error(`Failed to delete company-config ${id}:`, err);
    throw err;
  }
};

export const SAPCompanyConfigDataService = {
  createCompanyConfig,
  getAllCompanyConfigs,
  getCompanyConfigById,
  updateCompanyConfig,
  deleteCompanyConfig
};
